import { Injectable } from '@angular/core'
import { CardTypes } from '../models/card-types.enum';
import { CreditCardType } from '../shared/core/ovs.core';

@Injectable()
export class CreditCardService{

    constructor(){}

    getCreditCardType(acceptCardTypes:Array<CreditCardType>, cardNumber: string, merchantVersion: number = 11):CardTypes
    {
        let cardType = this.determineCardType(cardNumber, merchantVersion);

        let acceptedCardType = acceptCardTypes.where(t => t.Id == cardType).firstOrDefault();

        if(acceptedCardType!=null) return cardType;

        return cardType == CardTypes.Unknown? cardType: CardTypes.Unsupported;
    }

    determineCardType(cardNumber: string, merchantVersion?: number ){

        if (cardNumber == undefined || cardNumber.length == 0)
        {
            return CardTypes.Unknown;
        }
       
        if (cardNumber.substring(0, 1) == "4")
        {
            return CardTypes.Visa;
        }

        if(cardNumber.length >=2){
            
            switch (cardNumber.substring(0, 2))
            {
                case "34":
                case "37":
                    return CardTypes.AmericanExpress;
            }

            if (merchantVersion != 10) {
                switch (cardNumber.substring(0, 2))
                {
                    case "51":
                    case "52":
                    case "53":
                    case "54":
                    case "55":
                        return CardTypes.MasterCard;
                    case "64":
                    case "65":
                        return CardTypes.Discover;
                }
            }

            if(cardNumber.length >=3){
                switch (cardNumber.substring(0, 3))
                {
                    case "622":
                        return CardTypes.Discover;
                }
            }
           
            if(cardNumber.length >=4){
                switch (cardNumber.substring(0, 4))
                {
                    case "6019":
                        return CardTypes.MilitaryStarCard;
                    case "6011":
                        return CardTypes.Discover;
                }
            }
   
                
        }
         
        if(cardNumber.length >=6){
            var bin = Number.parseInt(cardNumber.substring(0, 6));

            switch (bin)
            {
                case 380000:
                case 381000:
                case 382000:
                case 383000:
                case 504994:
                    return CardTypes.Sears;
                case 700600:
                case 777700:
                case 700801:
                    return CardTypes.SearsGiftCard;
            }

            if (merchantVersion == 10) // Sears Gift Card
            {
                if (bin >= 600000 && bin <= 689999)
                {
                    return CardTypes.SearsGiftCard;
                }
            }
            else
            {
                // Mastercard 2-Series BIN Implementation
                if (bin >= 222100 && bin <= 272099)
                {
                    return CardTypes.MasterCard;
                }
            }
        }

        return CardTypes.Unknown;
    
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/creditcard.service.ts